import React from "react";
import { useRouter, withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { CTAContainer, ContentContainer, SubTitle, SuccessContainer, SuccessImage, Title, TitleContainer } from "./SuccessInvitedToTicket.styles";
import Logo from '../../../../../public/images/logo-new.svg';
import { Button, List } from "../../../../components";
import Link from "next/link";
import { StyledBlueSpan } from "../Success/Success.styles";

interface SuccessProps extends WithRouterProps {
  firstName: string | undefined;
  bookingInterestId: number | undefined | null;
}

const Success: React.FC<SuccessProps> = ({
  firstName,
  bookingInterestId,
}) => {
  const router = useRouter();

  return (
    <SuccessContainer
      data-cy="booking-interest-registration-success"
      data-bookinginterest-id={bookingInterestId}>
      <TitleContainer>
        <SuccessImage>
          <Logo />
        </SuccessImage>
        <Title>
          Congratulations {firstName}!
        </Title>
      </TitleContainer>
      <ContentContainer>
        <SubTitle>
          You’ve already been Invited to receive Tickets!
        </SubTitle>
        <List elements={[
          <>The countdown has begun! Accept your ticket (and any dependant’s tickets) now before time runs out.</>,
          <>Any guests in your booking will have a ticket offer too! Shoot them a text and ask them to check their inbox (and SPAM/Promotions folder) pronto.</>,
          <>If your guests still can’t see the email, check and change their email address in your profile under 
          <Link href="/profile?tab=tickets"><StyledBlueSpan> Applications & Tickets </StyledBlueSpan></Link> - Manage My Booking.</>
        ]} />
      </ContentContainer>
      <CTAContainer>
        <Button data-cy="accept-ticket-now-button" onClick={() => router.push('/profile')}> ACCEPT YOUR TICKET NOW! </Button>
      </CTAContainer>
    </SuccessContainer>
  );
};

export default withRouter(Success);
